<template>
  <ul :class="[{ 'm-edition-billing-contents-list-child': isChild }, 'm-edition-billing-contents-list']">
    <li :class="[{ 'm-edition-billing-contents-list-item-drag': !disabledDragg }, 'm-edition-billing-contents-list-item']">
      <div class="m-edition-billing-contents-list-item-data"
      >
        <a
          class="m-edition-billing-contents-list-item-data-name"
          href="#"
          @click.prevent="toggleChildren"
        >
          <i
            :id="`node-icon-caret-${nodo.id}`"
            :class="showChildren && nodo.children.length ? 'fas fa-caret-down' : 'fas fa-caret-right'"
          >
          </i>
          <span :class="nodeStateClass">
            {{ nodo.nombre }}
            <small v-if="nodo.children.length">
              ({{ nodo.children.length }} {{ $t('mEditionBillingContentsTreeNodes.subcontents') }})
            </small>
          </span>
        </a>
        <div :class="`m-edition-billing-contents-list-item-data-actions-${nodeActionsClass}`">
          <span class="node-activation-date">
            {{ diaNodo != 0 ? diaNodo : ''  }} {{ activationDate }}
          </span>
        </div>
      </div>
      <transition-group
        name="a-transtion-slide"
        tag="li"
      >
        <MoleculeEditionBillingContentsTreeNode
          v-show="showChildren"
          v-for="child in nodo.children"
          :key="child.id"
          :contenido="contenido"
          :disabledDragg="disabledDragg"
          :disabledSelected="disabledSelected"
          :element="element"
          :info="info"
          :is-child="true"
          :nodo="child"
          :node-actions="nodeActions"
          :node-actions-class="nodeActionsClass"
          :parent="nodo"
        />
      </transition-group>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'MoleculeEditionBillingContentsTreeNode',

  props: {
    contenido: Object,

    disabledDragg: {
      type: Boolean,
      default: true
    },

    disabledSelected: {
      type: Boolean,
      default: true
    },

    element: Object,

    info: {
      type: Object,
      default: () => ({})
    },

    isChild: Boolean,

    nodo: Object,
    nodeActions: String,
    nodeActionsClass: String,

    parent: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      diaNodo: '',
      moleculeNodeActions: '',
      showChildren: true
    }
  },

  created () {
    let dia = this.searchDay(this.nodo.id)
    this.diaNodo = dia === -1 ? '' : dia
  },

  computed: {
    activationDate () {
      if (this.diaNodo === '') {
        return this.$t('mEditionBillingContentsTreeNodes.messages.notActivated')
      } else if (this.diaNodo === 0) {
        return this.element.fecha_inicio
          ? this.$moment.parseZone(this.element.fecha_inicio).format('YYYY-MM-DD')
          : this.$t('mEditionBillingContentsTreeNodes.messages.inmediate')
      } else {
        return this.element.fecha_inicio
          ? this.$moment.parseZone(this.element.fecha_inicio).add(parseInt(this.diaNodo), 'days').format('YYYY-MM-DD')
          : this.$t('mEditionBillingContentsTreeNodes.messages.daysAfter')
      }
    },

    nodeStateClass () {
      return ''
    }
  },

  methods: {
    toggleChildren () {
      this.showChildren = !this.showChildren
    },

    searchDay (idNodo) {
      return parseInt(this.info.nodosActivos.nodos.find(anodo => anodo.nodo === idNodo).dia)
    }
  }
}
</script>
